import { render, staticRenderFns } from "./finance2.vue?vue&type=template&id=72f200ce"
import script from "./finance2.vue?vue&type=script&lang=js"
export * from "./finance2.vue?vue&type=script&lang=js"
import style0 from "./finance2.vue?vue&type=style&index=0&id=72f200ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports